const SET_ERROR = 'auth/SET_ERROR';
const SET_LOADING = 'auth/SET_LOADING';
const SET_USER = 'auth/SET_USER';
const SET_SHIPPER = 'auth/SET_SHIPPER';
const SET_CREDENTIALS = 'auth/SET_CREDENTIALS';

const sendUserInvitation$ = 'auth/sendUserInvitation$';
const updateUser$ = 'auth/updateUser$';
const login$ = 'auth/login$';
const signUp$ = 'auth/signUp$';
const logout$ = 'auth/logout$';

export default {
  SET_ERROR,
  SET_LOADING,
  SET_USER,
  SET_SHIPPER,
  SET_CREDENTIALS,
  sendUserInvitation$,
  updateUser$,
  login$,
  signUp$,
  logout$,
};
